<template>
  <CFooter :fixed="false">
    <div>
      <a href="https://bqv.gr" target="_blank"><img id="footerIcon" src="./Logo/footerIcon.png" /></a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}} All Right Reserved.</span>
    </div>
    <div class="ml-auto">
      <span class="mr-1" target="_blank">Crafted by</span>
      <a href="https://kukarika.com">Kukarika</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>

